// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"d50a3c04","44":"3f8ea661","169":"d70a5ecb","219":"dc52a870","366":"37686609","498":"b767d23e","568":"eecaea63","816":"31964128","995":"88455a57"}[chunkId] + ".chunk.js";
};